import { PaymentElement, useElements, useStripe, CardElement } from "@stripe/react-stripe-js";
import type { SetupIntentResult } from "@stripe/stripe-js";
import { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { PaymentProcessorHandler } from "../interface";
import { PaymentService } from "../../../services/payment/";
import { BookingModel, InvoiceModel, PaymentStatus } from "../../../data/entities";
import { SpinnerDefault } from "../../../components";

export interface StripeFormProps {
  invoice: InvoiceModel;
  booking: BookingModel;
  setPaymentStatus: React.Dispatch<React.SetStateAction<string|null>>
}
export const StripeForm = forwardRef<PaymentProcessorHandler, StripeFormProps>((props, ref)=> {

  const stripe = useStripe();
  const elements = useElements();
  const paymentService = new PaymentService();

  const [errorMessage, setErrorMessage] = useState<string | null>("");
  const [loading, setLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState<string | null>(null);


  const handleError = (error: any)=> {
    setLoading(false);
    setErrorMessage(error.messasge);
  }

  useEffect(() =>{
    const fetchClientSecret = async () => {
      const secret = await paymentService.createStripeClientSecretAsync(props.invoice);
      setClientSecret(secret);
    
    };
    fetchClientSecret();
   
  }, [props.invoice]);

  const handleSubmit = async (event: any) => {

    event.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true);

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      handleError(submitError);
      return;
    }

    const setupIntentResult: SetupIntentResult = await stripe.confirmSetup({
    elements,
      clientSecret: clientSecret!,
      confirmParams: {
        return_url: "https://localhost/stripe-return"
      },
      redirect: "if_required",
    });
    
    const paymentMethod = setupIntentResult.setupIntent?.payment_method;
    const token = typeof paymentMethod === "string" ? paymentMethod : paymentMethod?.id ?? "";
    const results = await paymentService.processPaymentAsync({invoiceId: props.invoice.id, total: props.invoice.total , token});


    if(results.status === PaymentStatus.Posted){
      setLoading(false);
      props.setPaymentStatus("succeeded")

    }else{
      setLoading(false);
      props.setPaymentStatus("failed")
    }

  };

 useImperativeHandle(ref, ()=>({
    handleSubmit,
  }))

  return (
    <form onSubmit={handleSubmit}>
      {loading && <SpinnerDefault/>}
     <PaymentElement />
    </form>
  );

})
export default StripeForm;
